import React from "react";
import { Button } from "components/ui/button";
import { toast } from "components/ui/use-toast";

const FILE_NAME = "Relatorio_Saldo_Caixa.xlsx"; 
const MIME_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"; 

interface ExportButtonProps {
  excelFile: string;
}

export const ExportButton: React.FC<ExportButtonProps> = ({ excelFile }) => {
  const exportToExcel = () => {
    if (!excelFile || !excelFile.startsWith(`data:${MIME_TYPE};base64,`)) {
      toast({
        description: "Nenhum arquivo disponível para download.",
        variant: "destructive",
      });
      return;
    }

    try {
      const base64Data = excelFile.split(",")[1];
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length)
        .fill(0)
        .map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: MIME_TYPE });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = FILE_NAME; // Usando a constante
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast({
        description: "Download iniciado com sucesso!",
        variant: "success",
      });
    } catch (error) {
      toast({
        description: "Erro ao processar o arquivo.",
        variant: "destructive",
      });
      console.error("Erro ao converter Base64 para Excel:", error);
    }
  };

  return (
    <Button onClick={exportToExcel} className="h-8">
      Exportar Relatório
    </Button>
  );
};
